import { getToken } from "helper/common";
import {
    CLEAR_ANTICOCCIDAL_LIST,
    SET_ANTICOCCIDAL_FILTER_DATA,
    SET_ANTICOCCIDAL_LIST,
    ANTICOCCIDAL_CREATE_DIALOG_CLOSE,
    ANTICOCCIDAL_CREATE_DIALOG_OPEN,
    ANTICOCCIDAL_CREATE_ERROR,
    ANTICOCCIDAL_CREATE_ERROR_CLEAR,
    ANTICOCCIDAL_CREATE_PENDING,
    ANTICOCCIDAL_EDIT_DIALOG_CLOSE,
    ANTICOCCIDAL_EDIT_DIALOG_OPEN,
    ANTICOCCIDAL_EDIT_ERROR,
    ANTICOCCIDAL_EDIT_ERROR_CLEAR,
    ANTICOCCIDAL_EDIT_PENDING,
    ANTICOCCIDAL_FILTER_DIALOG_CLOSE,
    ANTICOCCIDAL_FILTER_DIALOG_OPEN,
    ANTICOCCIDAL_LIST_ERROR,
    ANTICOCCIDAL_LIST_ERROR_CLEAR,
    ANTICOCCIDAL_LIST_PENDING,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
import { encodeObjectValues } from "helper/encodeData";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setAnticoccidalList = (anticoccidalList) => ({
    type: SET_ANTICOCCIDAL_LIST,
    payload: { anticoccidalList }
});

export const clearAnticoccidalList = () => ({
    type: CLEAR_ANTICOCCIDAL_LIST,
});

export const anticoccidalListPending = () => ({
    type: ANTICOCCIDAL_LIST_PENDING
});

export const anticoccidalListError = (errorMessage) => ({
    type: ANTICOCCIDAL_LIST_ERROR,
    payload: { errorMessage }
});

export const anticoccidalListErrorClear = () => ({
    type: ANTICOCCIDAL_LIST_ERROR_CLEAR
});

export const getAnticoccidalList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(anticoccidalListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.anticoccidalConfiguration.getAnticoccidalList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((anticoccidalList) => {
                dispatch(setAnticoccidalList(anticoccidalList));
                dispatch(anticoccidalListErrorClear());
                dispatch(anticoccidalEditErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(anticoccidalListError(message));
                }
                else {
                    dispatch(anticoccidalListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openAnticoccidalFilterDialog = () => ({
    type: ANTICOCCIDAL_FILTER_DIALOG_OPEN
});

export const closeAnticoccidalFilterDialog = () => ({
    type: ANTICOCCIDAL_FILTER_DIALOG_CLOSE
});

export const setAnticoccidalFilteredData = (filter) => ({
    type: SET_ANTICOCCIDAL_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openAnticoccidalCreateDialog = () => ({
    type: ANTICOCCIDAL_CREATE_DIALOG_OPEN
});

export const closeAnticoccidalCreateDialog = () => ({
    type: ANTICOCCIDAL_CREATE_DIALOG_CLOSE
});

export const anticoccidalCreatePending = () => ({
    type: ANTICOCCIDAL_CREATE_PENDING
});

export const anticoccidalCreateError = (errorMessage) => ({
    type: ANTICOCCIDAL_CREATE_ERROR,
    payload: { errorMessage }
});

export const anticoccidalCreateErrorClear = () => ({
    type: ANTICOCCIDAL_CREATE_ERROR_CLEAR
});

export const anticoccidalCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(anticoccidalCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.anticoccidalConfiguration.anticoccidalCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getAnticoccidalList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(anticoccidalCreateErrorClear());
                dispatch(closeAnticoccidalCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Anticoccidial successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(anticoccidalCreateError(message));
                }
                else {
                    dispatch(anticoccidalCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openAnticoccidalEditDialog = () => ({
    type: ANTICOCCIDAL_EDIT_DIALOG_OPEN
});

export const closeAnticoccidalEditDialog = () => ({
    type: ANTICOCCIDAL_EDIT_DIALOG_CLOSE
});

export const anticoccidalEditPending = () => ({
    type: ANTICOCCIDAL_EDIT_PENDING
});

export const anticoccidalEditError = (errorMessage) => ({
    type: ANTICOCCIDAL_EDIT_ERROR,
    payload: { errorMessage }
});

export const anticoccidalEditErrorClear = () => ({
    type: ANTICOCCIDAL_EDIT_ERROR_CLEAR
});

export const anticoccidalEdit = (formData, page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(anticoccidalEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.anticoccidalConfiguration.anticoccidalEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getAnticoccidalList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(anticoccidalEditErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Anticoccidial details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
                return Promise.resolve(true);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(anticoccidalEditError(message));
                }
                else {
                    dispatch(anticoccidalEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}